/*****
 *
 *  YOU SHALL NOT PASS
 *
 ****/
import { isFunction, isUndefined } from 'mc-ui-utils';
import colors from '../styles/colors';
import { toUTF8Array } from './common';
export const hasKhazaddumBridge = () => typeof window !== 'undefined' && !isUndefined(window.KhazadDumBridge);
export const getLocalImagePath = (glanceId) => {
    try {
        if (process.env.NODE_ENV === 'development') {
            return null;
        }
        return window.KhazadDumBridge.getLocalImagePath(glanceId);
    }
    catch (err) {
        console.error(err);
    }
};
export const getLocalOverlayImagePath = (glanceId) => {
    try {
        if (process.env.NODE_ENV === 'development') {
            return null;
        }
        return window.KhazadDumBridge.getLocalOverlayImagePath(glanceId);
    }
    catch (err) {
        console.error(err);
    }
};
const loaded = 0;
export const getGlances = (cb, limit = 20) => {
    try {
        if (process.env.NODE_ENV === 'development') {
            setTimeout(() => {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                //const glances = JSON.stringify(require('../mocks/glance.json'));
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const glances = require('../mocks/glance.json');
                const subset = glances.splice(loaded, loaded + limit);
                window.Gondolin.renderItems(JSON.stringify(subset));
            }, 100);
            return;
        }
        window.KhazadDumBridge.getGlances(cb, limit);
    }
    catch (err) {
        console.error(err);
    }
};
export const getWebPeekHTML = (glanceId, cb) => {
    try {
        if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const html = toUTF8Array(require('../mocks/webpeek').default);
            setTimeout(() => {
                window.Gondolin.renderWebpeek(html);
            }, 300);
            return;
        }
        window.KhazadDumBridge.getWebpeekHTML(glanceId, cb);
    }
    catch (err) {
        console.error(err);
    }
};
export const onGlanceShown = (glanceId) => {
    try {
        if (hasKhazaddumBridge()) {
            window.KhazadDumBridge.onGlanceShown(glanceId);
        }
    }
    catch (err) {
        if (process.env.NODE_ENV !== 'development') {
            console.error(err);
        }
    }
};
export const setImpressionId = (impressionId) => {
    var _a;
    try {
        if (hasKhazaddumBridge() &&
            isFunction(window.KhazadDumBridge.setImpressionId)) {
            (_a = window.KhazadDumBridge) === null || _a === void 0 ? void 0 : _a.setImpressionId(impressionId);
        }
    }
    catch (err) {
        if (process.env.NODE_ENV !== 'development') {
            console.error(err);
        }
    }
};
export const onShare = (glanceId, shareUrl, packageName, callback) => {
    try {
        if (process.env.NODE_ENV === 'development') {
            return;
        }
        window.KhazadDumBridge.shareGlance(glanceId, shareUrl, packageName, callback);
    }
    catch (err) {
        console.error(err);
    }
};
export const likeGlance = (glanceId) => {
    try {
        if (hasKhazaddumBridge()) {
            window.KhazadDumBridge.likeGlance(glanceId);
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const unLikeGlance = (glanceId) => {
    try {
        if (hasKhazaddumBridge()) {
            window.KhazadDumBridge.unLikeGlance(glanceId);
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const openCTAView = (glanceId, cb) => {
    try {
        if (hasKhazaddumBridge()) {
            window.KhazadDumBridge.launchCtaDialog(glanceId, cb);
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const openSettings = () => {
    try {
        if (hasKhazaddumBridge()) {
            window.KhazadDumBridge.openSettingsScreen();
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const openLanguages = () => {
    try {
        if (hasKhazaddumBridge()) {
            window.KhazadDumBridge.openLanguageScreen();
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const setWallpaper = (glanceId, attribution, cb) => {
    try {
        if (hasKhazaddumBridge()) {
            window.KhazadDumBridge.setWallpaper(glanceId, attribution, cb);
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const sendFeedback = (glanceId, callback) => {
    try {
        if (hasKhazaddumBridge()) {
            window.KhazadDumBridge.sendFeedback(glanceId, callback);
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const logAnalytics = (eventName, properties) => {
    var _a;
    try {
        console.debug(`%c Analytics data: ${eventName} ${properties}`, `background: ${colors.white}; color: ${colors.glanceRed};padding: 2px;`);
        if (isFunction((_a = window.KhazadDumBridge) === null || _a === void 0 ? void 0 : _a.logEvent)) {
            window.KhazadDumBridge.logEvent(eventName, properties);
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const getPeekSource = () => {
    try {
        if (hasKhazaddumBridge()) {
            return window.KhazadDumBridge.getPeekSource();
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const replaceMacroFromUrl = (url, glanceId) => {
    try {
        if (hasKhazaddumBridge()) {
            return window.KhazadDumBridge.replaceMacros(url, glanceId);
        }
    }
    catch (err) {
        console.error(err);
    }
    return url;
};
export const registerHighlightsOnClose = (cb) => {
    var _a;
    try {
        if (hasKhazaddumBridge()) {
            return (_a = window.KhazadDumBridge) === null || _a === void 0 ? void 0 : _a.registerHighlightsCloseListener(cb);
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const getNetworkType = () => {
    var _a;
    try {
        if (hasKhazaddumBridge()) {
            return (_a = window.KhazadDumBridge) === null || _a === void 0 ? void 0 : _a.getNetworkType();
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const getStartSource = () => {
    var _a;
    try {
        if (hasKhazaddumBridge() &&
            isFunction((_a = window.KhazadDumBridge) === null || _a === void 0 ? void 0 : _a.getStartSource)) {
            return window.KhazadDumBridge.getStartSource();
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const getEndSource = () => {
    var _a;
    try {
        if (hasKhazaddumBridge() &&
            isFunction((_a = window.KhazadDumBridge) === null || _a === void 0 ? void 0 : _a.getEndSource)) {
            return window.KhazadDumBridge.getEndSource();
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const hasUserLikedGlance = (glanceId) => {
    try {
        if (hasKhazaddumBridge() &&
            isFunction(window.KhazadDumBridge.getUserHasLikedGlance)) {
            return window.KhazadDumBridge.getUserHasLikedGlance(glanceId);
        }
        return false;
    }
    catch (err) {
        console.error(err);
    }
};
export const passSessionIdToSDK = (sessionId) => {
    var _a;
    try {
        if (hasKhazaddumBridge() &&
            isFunction((_a = window === null || window === void 0 ? void 0 : window.KhazadDumBridge) === null || _a === void 0 ? void 0 : _a.setHighlightSessionId)) {
            window.KhazadDumBridge.setHighlightSessionId(sessionId);
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const getUserId = () => {
    try {
        if (hasKhazaddumBridge() && isFunction(window.KhazadDumBridge.getUserId)) {
            return window.KhazadDumBridge.getUserId();
        }
    }
    catch (err) {
        console.error(err);
    }
};
//# sourceMappingURL=khazaddumbridge.js.map